import './clientDynamicNotes.less';

import React from 'react';
import { Icon, Dialog } from 'b3';
import { connect } from 'react-redux';
import KeyBinder from '../../utils/KeyBinder';
import api from '../../api';
import defaultNoteTypes from '../../constants/defaultNoteTypes';

@connect(
    state => ({
        secondaryBackgroundColour: state.theme.selected.secondaryBackground.value,
        secondaryBackgroundTextColour: state.theme.selected.secondaryBackground.text
    })
)
export default class ClientDynamicNotes extends React.Component {
    constructor(props) {
        super(props);

        var notes = this._getPopulatedNotesArray();

        this.state = {
            notes: notes,
            noteTypes: [],
            isDialogActive: false
        };

        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.onTabClose = this.onTabClose.bind(this);
    }

    async componentDidMount(){
        var types = await api.get('note_types');
        this.setState({ noteTypes: types.value });
    }

    _getPopulatedNotesArray() {
        var clientNotes = this.props.client.globalNotes.map((o, i) => {
            return {
                id: o.id,
                type: o.type,
                value: o.value,
                isEditing: false,
                isActive: 0,
                isDirty: false
            };
        });
        
        var defaultNotes    = clientNotes.filter(o => defaultNoteTypes.filter(d => d.label == o.type).length > 0);
        var nonDefaultNotes = clientNotes.filter(o => ! defaultNoteTypes.filter(d => d.label == o.type).length > 0);

        var notes = defaultNoteTypes.map(type => {
            var noteData = defaultNotes.filter(note => note.type === type.label);

            if(noteData.length) {
                return noteData[0];
            } else {
                return {
                    type: type.label,
                    value: type.value,
                    isEditing: false,
                    isActive: 0,
                    isDirty: false
                };
            }
        });

        notes = notes.concat(nonDefaultNotes);
        notes[0].isActive = 1;

        return notes;
    }

    onTabInputFocus(){
        this.keyBinder = new KeyBinder({
            escapePressed: this.onEsc.bind(this),
            enterPressed: this.onEnter.bind(this)
        });
    }

    onTabInputBlur  = this._tabSave;
    onEnter         = this._tabSave;

    _tabSave(){
        if(this.keyBinder)
            this.keyBinder.destroy();

        this.setState({
            notes: this.state.notes.map(o => { o.isEditing = false; return o; })
        });
    }

    onEsc(){
        var notes = this.state.notes.filter(o => o.isEditing == false);
        notes[notes.length - 1].isActive = true;

        this.setState({
            notes: notes
        });

        this.keyBinder.destroy();
    }

    onTabClick(noteIndex){
        console.log(noteIndex);
        console.log(this.state.notes[noteIndex]);

        var notes = this.state.notes.map((o, i) => {
            o.isActive = (noteIndex === i) ? 1 : 0;
            return o;
        });

        this.setState({notes: notes});
    }

    onTabAdd(e) {
        var notes = this.state.notes.map(t => ({
            ...t,
            isEditing: false,
            isActive: false,
        }))
        .concat({
            type: '',
            value: '',
            isEditing: true,
            isActive: true,
            isDirty: false,
            id: null
        });

        this.setState({
            notes: notes
        });
    }

    onTabEdit(noteIndex, input){
        input.target.value = titleCase(input.target.value);

        var notes = this.state.notes.map((note, i) => {
            if(noteIndex === i){
                note.type = input.target.value;
                note.isDirty = true;
            }

            return note;
        });

        this.setState({
            notes: notes
        });
    }

    async onTabClose(){
        var prevIndex;
        var noteId;
        var clientId = this.props.client.id;

        var notes = this.state.notes.filter((o, i) => {
            if(o.isActive){
                prevIndex = (i - 1);
                noteId = o.id;
            }

            return ! o.isActive;
        });

        prevIndex = prevIndex && prevIndex >= 0 ? prevIndex : 0;
        notes[prevIndex].isActive = true;

        if(noteId)
            await api.delete(`clients/${clientId}/global_notes/${noteId}`);

        this.setState({
            notes: notes,
            isDialogActive: false
        });
    }

    onNoteEdit(e){
        var notes = this.state.notes.map(o => {
            if(o.isActive){
                o.value = e.target.value;
                o.isDirty = true;
            }

            return o;
        });

        this.setState({ notes: notes });
    }

    async onSaveClick(activeNote){
        var clientId = this.props.client.id;
        var result = await api.post(`clients/${clientId}/global_notes`, {note: activeNote});

        var notes = this.state.notes.map(o => {
            if(o == activeNote){
                o.id = result.value.id;
                o.isDirty = false;
                o.isEditing = false;
            }
            
            return o;
        });

        this.setState({notes: notes});
    }

    showDialog(){
        this.setState({ isDialogActive: true });
    }

    handleDialogClose(){
        this.setState({ isDialogActive: false });
    }

    handlePredictionClick(prediction){
        var activeTab = this.state.notes.filter(o => o.isEditing)[0];
        activeTab.type = prediction;
        activeTab.isEditing = false;

        this.setState({...this.state, activeTab});
    }

    getTextPredictions(){
        var { noteTypes, notes } = this.state;
        var activeTab = notes.filter(o => o.isEditing)[0];

        if(! noteTypes || ! activeTab)
            return '';

        if(activeTab.type === '')
            return '';

        return noteTypes.filter(o => o.toUpperCase().startsWith(activeTab.type.toUpperCase()));
    }

    render() {
        var { notes, isDialogActive } = this.state;
        var activeNote = notes.filter(o => o.isActive)[0];

        var textPredictions = this.getTextPredictions();
        var predictText = textPredictions[0];

        var isShowingPredictions = textPredictions.length > 0 && activeNote.isEditing;

        return (
            <div className="clientDynamicNotes">
                <div className="clientDynamicNotes__header">
                    {notes.map((note, i) => 
                        <div
                            className={note.isActive ? "clientDynamicNotes__header__item clientDynamicNotes__header__item--active" : "clientDynamicNotes__header__item"}
                            key={i}

                        >
                            {note.isEditing === true &&
                                <div className="clientDynamicNotes__input">
                                    <input
                                        type="text"
                                        className="clientDynamicNotes__header__item__edit"
                                        onChange={input => this.onTabEdit(i, input)}
                                        onFocus={ this.onTabInputFocus.bind(this) }
                                        ref={o => {if(o)o.focus(); return this.editRef = o}}

                                        onClick={o => this.onTabClick(i)}
                                    />
                                    <span className="clientDynamicNotes__input__predict" onClick={o => this.editRef.focus()}>{predictText}</span>

                                    {isShowingPredictions &&
                                        <div className="clientDynamicNotes__input__predictionResults">
                                            {textPredictions.map(o => 
                                                <div key={o} className="clientDynamicNotes__input__predictionResults__result" onClick={() => this.handlePredictionClick(o)}>{o}</div>
                                            )}
                                        </div>
                                    }
                                </div>
                            }

                            {! note.isEditing && 
                                <div onClick={o => this.onTabClick(i)} className="clientDynamicNotes__label">{note.type} </div>
                            }
                            {i > 0 && <Icon icon="cross" onClick={this.showDialog.bind(this)}/>}
                        </div>
                    )}
                    <div className="clientDynamicNotes__header__item clientDynamicNotes__header__item--add" onClick={this.onTabAdd.bind(this)}><Icon icon="add-1" /></div>
                </div>

                <div className="clientDynamicNotes__content"
                    onClick={o => this.onTabInputBlur()}
                >
                    <textarea
                        style={{backgroundColor: this.props.secondaryBackgroundColour, color: this.props.secondaryBackgroundTextColour}}
                        ref={ el => this.textarea = el }
                        value={activeNote.value}
                        onChange={ e => {this.onNoteEdit(e)} }
                        placeholder="Type Notes Here..."
                    />
                    
                    <span className="clientDynamicNotes__editIcon"><Icon icon="edit-3" /></span>

                    {activeNote.isDirty && 
                        <button className="btn btn-success clientDynamicNotes__save" onClick={this.onSaveClick.bind(this, activeNote)}><Icon icon="check-1" /></button>
                    }
                </div>

                {isDialogActive &&
                    <Dialog onCancel={this.handleDialogClose} onPrimaryAction={this.onTabClose} title={''} showHeader={false}>
                        <div style={{padding: "30px 50px", fontSize: 16, fontWeight: 'bold'}}>{"Are you sure you'd like to delete this tab?"}</div>
                    </Dialog>
                }
            </div>
        );
    }
}

//Title Case (test test => Test Test) function taken from below
//https://stackoverflow.com/questions/32589197/capitalize-first-letter-of-each-word-in-a-string-javascript
function titleCase(str) {
   var splitStr = str.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       // You do not need to check if i is larger than splitStr length, as your for does that for you
       // Assign it back to the array
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
   }
   // Directly return the joined string
   return splitStr.join(' '); 
}



// WEBPACK FOOTER //
// ./app/components/clients/ClientDynamicNotes.js